export default "__VITE_ASSET__BupEBVgh__"